import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { MAIN_SECTION_MIN_HEIGHT_SX } from "./layoutConstants";

export default function MainSectionShell({ children, sx, ...props }) {
    return (
        <Box
            sx={{
                width: "100%",
                minWidth: 0,
                flex: 1,
                alignSelf: "stretch",
                minHeight: MAIN_SECTION_MIN_HEIGHT_SX,
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
                ...sx,
            }}
            {...props}
        >
            {children}
        </Box>
    );
}

MainSectionShell.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.object,
};
